import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import PropTypes from "prop-types";
import SvgIcon from "components/Common/SvgIcon";
import ResponseEditorTrainerExpression from "components/Pages/Responses/ResponsesEditor/ResponseEditorTrainer/ResponseEditorTrainerExpression";
import { ExpressionRecord } from "reducers/expressions/reducer";
import "./style.scss";

export const BLOCK_NAME = "ExpressionErrorList";

/**
 * @param {Immutable.List} errorExpressions
 * @param {String} errorMessage
 */
export class ExpressionErrorList extends React.PureComponent {
  /**
   * @returns {ReactElement}
   */
  render() {
    const { errorExpressions, errorMessage } = this.props;

    if (!errorExpressions.size) {
      return null;
    }

    return (
      <div className={`${BLOCK_NAME}__error-list-wrapper`}>
        <SvgIcon
          icon="WarningYellow"
          customClassName={`${BLOCK_NAME}__error-list-warning-icon`}
        />
        {errorMessage}
        <div className={`${BLOCK_NAME}__error-list`}>
          {errorExpressions.map((expr, index) => (
            <ResponseEditorTrainerExpression
              key={expr.get("body")}
              index={index}
              expression={expr}
              readOnly
            />
          ))}
        </div>
      </div>
    );
  }
}

ExpressionErrorList.propTypes = {
  errorExpressions: ImmutablePropTypes.listOf(ExpressionRecord).isRequired,
  errorMessage: PropTypes.string.isRequired
};
